import axios from "axios";
import { REACT_APP_DOMAIN_URL } from "features/shared/constants";
import { formListParam, MoneyUpdateEdit } from "../core/ms6.param";
import { DailyAttendanceTableData } from "../core/domain/DailyAttendanceTableData.model";
import { AttendanceStaticData } from "../core/domain/DailyStaticData.model";
import { DailyIncidentTableData } from "../core/domain/DailyIncidentTableData.model";
import { IncidentStaticData } from "../core/domain/DailyStaticIncidentData.model";
import { DailyEfficiencyTableData } from "../core/domain/DailyEfficiencyTableData.model";
import { DailyInventoryTableData } from "../core/domain/DailyInventoryTableData.model";
import { DailySvrTableData } from "../core/domain/DailySvrTableData.model";
import { DailyProduct } from "../core/domain/DailyProductData.model";

/**
 * Response data formListSubmitResponse
 */
export interface formListSubmitResponse {
  data: {
    message: string;
  };
}

/**
 * Response data formListSubmitResponse
 */
export interface dailyAttendanceFieldResponse {
  data: {
    data: any; // change this with new model
    message: string;
  };
}

export interface dailyIncidentFieldResponse {
  data: {
    data: any; // change this with new model
    message: string;
  };
}

export interface dailyInventoryFieldResponse {
  data: {
    data: any; //change this with new model
    message: string;
  };
}

export interface dailyEfficiencyFieldResponse {
  data: {
    data: any; //change this with new model
    message: string;
  };
}

export interface dailySvrFieldResponse {
  data: {
    data: any; //change this with new model
    message: string;
  };
}

// Table Data for viewing Attendance Table Records
export interface DailyAttendanceTableDataResponse {
  data: {
    data: DailyAttendanceTableData;
    message: string;
  };
}

export interface DailyStaticDataResponse {
  data: {
    data: AttendanceStaticData;
    message: string;
  };
}

// Table data for viewing Incident records
export interface DailyIncidentTableDataResponse {
  data: {
    data: DailyIncidentTableData;
    message: string;
  };
}

export interface DailyIncidentDataResponse {
  data: {
    data: IncidentStaticData;
    message: string;
  };
}

export interface DailyProductResponse {
  data: {
    data: DailyProduct;
    message: string;
  };
}

// Table data for viewing Inventory records
export interface DailyInventoryTableDataResponse {
  data: {
    data: DailyInventoryTableData;
    message: string;
  };
}

// Table Data for viewing efficiency records
export interface DailyEfficiencyTableDataResponse {
  data: {
    data: DailyEfficiencyTableData;
    message: string;
  };
}

// Table Data for viewing Svr records
export interface DailySvrTableDataResponse {
  data: {
    data: DailySvrTableData;
    message: string;
  };
}

// Request response data for updating edit on svr data
export interface updateEditSvrResponse {
  data: {
    message: string;
  };
}

/**
 * Axios / repository that communicates with backend daily_attendance endpoint for post/submission
 */
export function formListRepository(
  param: formListParam
): Promise<formListSubmitResponse> {
  return axios.post(
    `${REACT_APP_DOMAIN_URL}api/form_6ms/daily_attendance`,
    param,
    {
      withCredentials: true,
    }
  );
}

/**
 * Axios / repository that communicates with backend daily_attendance endpoint for  get/fetching data
 */
export function dailyAttendanceFieldRepository(): Promise<dailyAttendanceFieldResponse> {
  return axios.get(`${REACT_APP_DOMAIN_URL}api/form_6ms/daily_attendance`, {
    withCredentials: true,
  });
}

export function dailyIncidentFieldRepository(): Promise<dailyIncidentFieldResponse> {
  return axios.get(`${REACT_APP_DOMAIN_URL}api/form_6ms/daily_incident`, {
    withCredentials: true,
  });
}

export function dailyInventoryFieldResponse(): Promise<dailyInventoryFieldResponse> {
  return axios.get(`${REACT_APP_DOMAIN_URL}api/form_6ms/daily_inventory`, {
    withCredentials: true,
  });
}

export function dailyEfficiencyFieldResponse(): Promise<dailyEfficiencyFieldResponse> {
  return axios.get(`${REACT_APP_DOMAIN_URL}api/form_6ms/daily_efficiency`, {
    withCredentials: true,
  });
}

export function dailySvrFieldResponse(): Promise<dailySvrFieldResponse> {
  return axios.get(`${REACT_APP_DOMAIN_URL}api//DailySvr/generateSvr`, {
    withCredentials: true,
  });
}

export function DailyAttendanceTableDataRepository(): Promise<DailyAttendanceTableDataResponse> {
  return axios.get(
    `${REACT_APP_DOMAIN_URL}api/form_6ms/daily-attendance-data`,
    {
      withCredentials: true,
    }
  );
}

export function DailyIncidentTableDataRepository(): Promise<DailyIncidentTableDataResponse> {
  return axios.get(`${REACT_APP_DOMAIN_URL}api/form_6ms/daily-incident-data`, {
    withCredentials: true,
  });
}

export function DailyInventoryTableDataRepository(): Promise<DailyInventoryTableDataResponse> {
  return axios.get(`${REACT_APP_DOMAIN_URL}api/form_6ms/daily-inventory-data`, {
    withCredentials: true,
  });
}

export function DailyEfficiencyTableDataRepository(): Promise<DailyEfficiencyTableDataResponse> {
  return axios.get(
    `${REACT_APP_DOMAIN_URL}api/form_6ms/daily-efficiency-data`,
    {
      withCredentials: true,
    }
  );
}

// For Getting Table Data Records
export function DailySvrTableDataRepository(): Promise<DailySvrTableDataResponse> {
  return axios.get(`${REACT_APP_DOMAIN_URL}api/form_6ms/generateSvr`, {
    withCredentials: true,
  });
}

export function DailyStaticDataRepository(): Promise<DailyStaticDataResponse> {
  return axios.get(`${REACT_APP_DOMAIN_URL}api/form_6ms/daily_attendance`, {
    withCredentials: true,
  });
}

// get product table
export function DailyProductRepository(): Promise<DailyProductResponse> {
  return axios.get(
    `${REACT_APP_DOMAIN_URL}api/form_6ms/Daily_product_dropdown`,
    {
      withCredentials: true,
    }
  );
}

// update edit on svr
export function updateEditSvrRepository(
  param: MoneyUpdateEdit
): Promise<updateEditSvrResponse> {
  return axios.put(
    `${REACT_APP_DOMAIN_URL}api/money/svr/edit/edit-svr-data`,
    param,
    {
      withCredentials: true,
    }
  );
}
